import React from 'react';
import { fromPairs, map, get, isEqual, find } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { submitAuthEpostId as SubmitAuthEpostId } from 'ui/views/widgets/submitAuthEpostId';
 *
 * // render
 * <SubmitAuthEpostId propName='propValue'/>
 */
export const submitAuthEpostId = ( props ) => {
    return (
        <div className='submit-auth-epost-id'>

            {/* header */}
            <div className='submit-auth-epost-id__header'>

                {/* title */}
                <div className='submit-auth-epost-id__header__title'>
                    { getLabel( props.title ) }
                </div>

                {/* close button */}
                {
                    'edit' === props.mode ? (
                        <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                            <Icon name='close' width='14' height='14' fill='#ffffff' />
                        </div>
                    ) : null
                }
            </div>

            {/* form container */}
            <div className='submit-auth-epost-id__body'>
				<Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.values } // default values
                    isValid={ false }
                    mode={ props.mode }
                    onSubmit={ ( { values, isValid } ) => {
                        if( isValid ) {
                            props.onSubmit( {
                                values,
                                url: get( find( props.actions, { name: 'save' } ), 'url', null ),
                                webSocketConfig: props.webSocketConfig
                            } );
                        }
                    } }
                >
                    { ( { fields, values, errors, onChange, onSumbit } = {} ) => {

                        return (
                            <form className='submit-auth-epost-id__body__form' onSubmit={ onSumbit }>
                                { /* fields */ }
                                { map( fields, ( field ) => {
                                    return (
                                        <field.view
                                            className='submit-auth-epost-id__body__form__field'
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                        />
                                    );
                                } ) }

                                {/* button actions */}
                                <div className='submit-auth-epost-id__body__form__actions'>
                                    { map( props.actions, action => {
                                        return (
                                            <Button
                                                key={ action.name }
                                                id= { action.name }
                                                className='submit-auth-epost-id__body__form__actions__action'
                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                { ...action }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='medium'
                                                onClick = { isEqual( 'cancel', action.name ) ? () => props.closeOverlay() : null }
                                            />
                                        );
                                    } ) }
                                </div>
                            </form>
                        );
                    } }
                </Form>
			</div>
        </div>
    );
};

// set display name
submitAuthEpostId.displayName = 'submitAuthEpostId';

// set default props
submitAuthEpostId.defaultProps = {};

// prop types
submitAuthEpostId.propTypes = {};
